import { IApiChangeHistoryEvent, IApiColumnInfo, IApiDbActionCode } from '@tap/data-providers';
import { Typography, Link } from '@mui/material';
import { useMemo } from 'react';
import { ChangeHistoryColumnDiff } from '../../ChangeHistoryColumnDiff';
import { useDialog } from '../../../Dialog';
import TransactionInfoDialog from '../../TransactionInfoDialog';
import { ChangeHistorySlotComponent } from '../../change-history.types';
import { ColumnValueSlotProps } from '../../ChangeHistoryColumnValue';


export type EventDescriptionSlotProps<T = unknown> = {
    eventItem: IApiChangeHistoryEvent<T>,
    columnList: IApiColumnInfo[],
    slots?: ChangeHistorySlotComponent<ColumnValueSlotProps>,
    slotProps?: ColumnValueSlotProps,
}

export const EventDescription_BaseSlot = ({ eventItem, columnList, slots, slotProps }: EventDescriptionSlotProps) => {

    const diffList = useMemo(() => {
        return (eventItem.diff ?? []).map(col => ({
            col,
            info: columnList.find(c => c.columnName === col.k)?.info,
        })).filter(d => !d.info?.isHide);
    }, [eventItem.diff]);

    const handleCloseTransactionDialog = ({ isCancel }: any) => {

        if (isCancel) return;
    };

    const TransactionInfoReadyDialog = useDialog(TransactionInfoDialog, handleCloseTransactionDialog);

    const handleOpenTransactionDialog = () => {
        TransactionInfoReadyDialog.open({ transactionId: eventItem.transactionId });
    }


    return (
        <>
            {
                diffList.map(item => (
                    <ChangeHistoryColumnDiff
                        key={item.col.k}
                        title={item.info?.title ?? item.col.k}
                        oldValue={item.col.o}
                        newValue={item.col.n}
                        columnInfo={item.info}
                        slots={slots}
                        slotProps={slotProps}
                    />
                ))
            }
            {eventItem.dbActionCode === IApiDbActionCode.Transaction && (
                <Typography component={Link} onClick={handleOpenTransactionDialog}>Подробнее</Typography>
            )}
            <TransactionInfoReadyDialog.Component />
        </>
    );
}